import React from 'react';
import PropTypes from 'prop-types';

import './chart-section.less';

const renderSummaryRows = (rows) =>
  rows.map((row, index) => {
    const { title, valueAmount, valueUnit } = row;
    const key = `row-${index}`;

    return (
      <div className="summary-row" key={key}>
        <div className="row-title-cell">
          <div className="row-title-text">{title}</div>
        </div>
        <div className="row-value">
          <span className="row-value-amount">{valueAmount}</span>
          <span className="row-value-unit">{valueUnit}</span>
        </div>
      </div>
    );
  });

const ChartSection = ({
  title,
  chartImgSrcDesktop,
  chartImgSrcMobile,
  summaryTitle,
  rows,
}) => (
  <div className="chart-section">
    <div className="chart-title">{title}</div>
    <img
      className="chart-large"
      src={chartImgSrcDesktop}
      alt="chart"
      role="presentation"
    />
    <img
      className="chart-small"
      src={chartImgSrcMobile}
      alt="chart"
      role="presentation"
    />
    <div className="summary">
      <div className="summary-title">{summaryTitle}</div>
      {renderSummaryRows(rows)}
    </div>
  </div>
);

ChartSection.propTypes = {
  title: PropTypes.string,
  chartImgSrcDesktop: PropTypes.string,
  chartImgSrcMobile: PropTypes.string,
  summaryTitle: PropTypes.string,
  rows: PropTypes.array,
};

ChartSection.displayName = 'ChartSection';

export default ChartSection;
